module.exports = __webpack_public_path__ + "img/home-header-title-bg.bb5616f7.png";